import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BlazeInverted = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M12.5542 16.0349C12.5769 16.0349 12.6018 16.0349 12.6288 16.035C13.2907 16.0372 15.1878 16.0434 16.6253 14.9463C17.6671 14.1513 18.2977 12.9039 18.2977 11.5332C18.2977 10.5737 18.1743 9.92942 17.6463 9.17552C17.6463 9.17552 18.75 8.20229 18.75 6.53867C18.75 4.6521 17.82 3.13474 15.6511 2.64462C15.0135 2.50054 13.4585 2.5 13.4585 2.5L8.31247 2.50109L3.31903 8.03192L1.25002 16.035L5.24203 16.0335L12.5542 16.0349Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.24203 16.0335L12.5542 16.0349C12.5769 16.0349 12.6018 16.0349 12.6288 16.035C13.2907 16.0372 15.1878 16.0434 16.6253 14.9463C17.6671 14.1513 18.2977 12.9039 18.2977 11.5332C18.2977 10.5737 18.1743 9.92942 17.6463 9.17552C17.6463 9.17552 18.75 8.20229 18.75 6.53867C18.75 4.6521 17.82 3.13474 15.6511 2.64462C15.0135 2.50054 13.4585 2.5 13.4585 2.5L8.31247 2.50109L3.31903 8.03192L1.25002 16.035L5.24203 16.0335Z"
          fill={color}
        />
        <path
          d="M6.3623 15.0116L8.99411 3.39893H14.2248C14.636 3.39893 15.5243 3.46472 16.0835 3.7279C17.1691 4.2378 17.5475 5.27406 17.5475 6.14583C17.5475 6.73798 17.383 7.33012 17.0211 7.80713C16.4618 8.56376 15.7381 8.7447 15.1624 8.89274C16.0671 9.30395 17.1362 9.78095 17.1362 11.5081C17.1362 12.4621 16.6921 13.3667 16.0013 13.9918C14.9815 14.9129 13.5669 15.0116 12.8267 15.0116H6.3623ZM11.3463 5.50434L10.7706 7.97162H12.9254C13.5175 7.93872 14.7183 7.88937 14.7183 6.55704C14.7183 5.57013 13.8794 5.52079 13.4353 5.50434H11.3463ZM10.2936 10.077L9.66851 12.8733H12.1852C12.8102 12.8568 13.4024 12.8404 13.83 12.2647C14.0603 11.9522 14.1261 11.5738 14.1261 11.2778C14.1261 11.0804 14.0932 10.8995 14.0274 10.735C13.7313 10.1264 13.1721 10.1099 12.7115 10.077H10.2936Z"
          fill="white"
        />
      </svg>
    )
  },
)

export default BlazeInverted
